import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { getAuthentication } from '../../../hooks/useAuthentication';

export default function useMarkStepDone() {
  const navigate = useNavigate();

  const markStepDone = async (stepUrl: string) => {
    const { user } = getAuthentication();
    localStorage.setItem(`current-step-${user?.id}`, stepUrl);
  };

  const onBoardingCompleted = async () => {
    localStorage.removeItem(`current-step-${getAuthentication()?.user?.id}`);
  };

  const checkCurrentStep = useCallback(async () => {
    const authentication = getAuthentication();

    if (authentication?.user?.onboardHomeCompleted || !authentication?.user?.id) {
      return;
    }

    const currentStep = localStorage.getItem(`current-step-${authentication?.user?.id}`);

    if (currentStep && currentStep.includes('/on-boarding/step-')) {
      navigate(currentStep);
    } else {
      navigate('/on-boarding/step-1');
    }
  }, [navigate]);

  return {
    markStepDone,
    onBoardingCompleted,
    checkCurrentStep,
  };
}
